;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import { graphRequest } from 'services/contentful';

import {
    assetFragment,
    ctaFragment,
    iconFragment,
    linkFragment,
    richtextLinkFragment,
} from 'lib/graphql/fragments';

import BlockPairingWheel from './BlockPairingWheel';

const query = /* GraphQL */ `
    ${assetFragment}
    ${ctaFragment}
    ${linkFragment}
    ${iconFragment}
    ${richtextLinkFragment}
    query getBlock($id: String!, $preview: Boolean!) {
        blockPairingWheel(preview: $preview, id: $id) {
            __typename
            entryTitle
            eyebrow
            headline {
                json
            }
            copy {
                json
                links {
                    entries {
                        block {
                            ...RichTextLink
                        }
                        inline {
                            ...RichTextLink
                        }
                        hyperlink {
                            ...RichTextLink
                        }
                    }
                }
            }
            image {
                ...Asset
            }
            itemsCollection {
                items {
                    eyebrow
                    headline {
                        json
                    }
                    copy {
                        json
                        links {
                            entries {
                                block {
                                    ...RichTextLink
                                }
                                inline {
                                    ...RichTextLink
                                }
                                hyperlink {
                                    ...RichTextLink
                                }
                            }
                        }
                    }
                    image {
                        ...Asset
                    }
                }
            }
            revealHeadline {
                json
            }
            revealCopy {
                json
                links {
                    entries {
                        block {
                            ...RichTextLink
                        }
                        inline {
                            ...RichTextLink
                        }
                        hyperlink {
                            ...RichTextLink
                        }
                    }
                }
            }
            viewGuideCta {
                ... on Cta {
                    ...CTA
                }
            }
            pairAgainCtaText
            revealImage {
                ...Asset
            }
            primaryColor
            secondaryColor
            loadingIcon {
                ... on Icon {
                    ...Icon
                }
            }
            loadingMessage1 {
                json
            }
            loadingMessage2 {
                json
            }
            loadingMessage3 {
                json
            }
            loadingMessage4 {
                json
            }
            nextPairingWheel {
                sys {
                    id
                }
            }
        }
    }
`;

async function fetchBlock(id) {
    const {
        body: {
            data: { blockPairingWheel },
        },
    } = await graphRequest({
        query,
        variables: { id, preview: false },
    });
    return blockPairingWheel;
}

const BlockPairingWheelServer = async ({ id }) => {
    const block = await fetchBlock(id);
    return <BlockPairingWheel {...block} items={block.itemsCollection.items} />;
};

export default BlockPairingWheelServer;
